import React from 'react';
import PropTypes from 'prop-types';
import tmpNames from './consts';
import Tmp1 from './Tmp1';
import Tmp2 from './Tmp2';
import Tmp3 from './Tmp3';


const RenderTemplates = ({tourTemplate, tmpProps}) => {
  switch (tourTemplate) {
    case tmpNames.tmp1:
      return (
        <Tmp1
          {...tmpProps}
        />
      );
    case tmpNames.tmp2:
      return (
        <Tmp2
          {...tmpProps}
        />
      );
    case tmpNames.tmp3:
      return (
        <Tmp3
          {...tmpProps}
        />
      );
    default:
      return null;
  }
};


RenderTemplates.propTypes = {
  tourTemplate: PropTypes.string,
  tmpProps: PropTypes.object,
};


export default RenderTemplates;


// WEBPACK FOOTER //
// ./src/app/containers/TourPage/components/Templates/index.js